/**
 * Backlog-field types — mirror the backend response DTO exactly.
 * BacklogFieldKind matches seedz.manage.enums.BacklogFieldKind.
 * BacklogSystemField matches seedz.manage.enums.BacklogSystemField.
 * BacklogFieldType matches seedz.manage.enums.BacklogFieldType.
 */

export type BacklogFieldKind = 'SYSTEM' | 'CUSTOM';

export type BacklogSystemField =
  | 'RECORD_ID'
  | 'DATE_FROM'
  | 'DATE_TO'
  | 'EXTERNAL_REF'
  | 'IM_REF'
  | 'DESCRIPTION'
  | 'PRIORITY'
  | 'STATUS'
  | 'EFFORT_MD'
  | 'WSJF'
  | 'OWNER'
  | 'DEVELOPER'
  | 'SCHED'
  | 'TOTAL_EFFORT_DAYS'
  | 'TASKS'
  | 'RAID_LINKS'
  | 'MILESTONE'
  | 'REMARKS';

export type BacklogFieldType =
  | 'TEXT'
  | 'LONG_TEXT'
  | 'NUMBER'
  | 'DATE'
  | 'SELECT'
  | 'CHECKBOX'
  | 'MEMBER';

/** One SELECT choice — {value, label}. */
export interface BacklogFieldOption {
  value: string;
  label: string;
}

/** One field of a project's configurable backlog schema. */
export interface BacklogField {
  id: string;
  projectId: string;
  fieldKey: string;
  label: string;
  kind: BacklogFieldKind;
  systemRef: BacklogSystemField | null;
  dataType: BacklogFieldType | null;
  options: BacklogFieldOption[] | null;
  required: boolean;
  sortOrder: number;
  archived: boolean;
}

/** The mandatory trio present in every project — reorderable but never
 *  archivable/deletable (backend: BacklogFieldValidator.MANDATORY_TRIO). */
export const BACKLOG_FIELD_MANDATORY_TRIO: readonly BacklogSystemField[] = [
  'RECORD_ID', 'DATE_FROM', 'DATE_TO',
];

/** One field of the project-creation wizard's local draft schema design —
 *  mirrors the backend's BacklogFieldSpec exactly (sortOrder is implicit:
 *  array position IS the order, per CreateProjectCommandService). */
export interface BacklogFieldSpec {
  kind: BacklogFieldKind;
  systemRef?: BacklogSystemField | null;
  label: string;
  dataType?: BacklogFieldType | null;
  options?: BacklogFieldOption[] | null;
  required: boolean;
}
